import React from 'react';
import {
  RadioButton,
  RadioButtonGroup,
} from 'material-ui';
import {
  translate as t,
} from 'admin-on-rest';
import TextRecord from '../FormInputs/TextRecord';

export const BINARY_TYPE = 'yesno';
export const defaultBinary = () => {
  const randomInteger = Math.floor(Math.random() * 1000);
  const now = new Date().getTime();
  return {
    id: `${now}${randomInteger}`,
    type: BINARY_TYPE,
    isCorrect: true,
  };
};

const TRANSLATION_PREFIX = 'resources.quizes.fields.questions';
const TRANSLATION_QUIZ_PREFIX = 'resources.quizes';
const YES = 'yes';
const NO = 'no';

class BinaryForm extends React.Component {
  isCorrectOnChange = (ev, payload) => {
    this.change('isCorrect', payload === YES);
  }

  change = (key, value) => {
    const delta = {};
    delta[key] = value;
    this.props.onChange(delta, this.props.id);
  }

  render() {
    const {
      isCorrect,
      translate,
    } = this.props;

    return (
      <>
        <TextRecord
          label={translate(`${TRANSLATION_PREFIX}.type`)}
          value={translate(`${TRANSLATION_QUIZ_PREFIX}.questions.binary`)}
        />
        <h4>{translate(`${TRANSLATION_PREFIX}.isCorrect`)}</h4>
        <RadioButtonGroup
          name="binary"
          defaultSelected={isCorrect ? YES : NO}
          onChange={this.isCorrectOnChange}
        >
          <RadioButton
            value={YES}
            label={translate(`${TRANSLATION_QUIZ_PREFIX}.yes`)}
          />
          <RadioButton
            value={NO}
            label={translate(`${TRANSLATION_QUIZ_PREFIX}.no`)}
          />
        </RadioButtonGroup>
      </>
    );
  }
}

export default t(BinaryForm);
